import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Tooltip, Tabs, Tab } from 'react-bootstrap';
import $ from 'jquery';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as driverRecordActions from '../../actions/driver_record/index';
import * as driverBehaviorActions from '../../actions/driver_behavior/index';
import * as accountDriverActions from '../../actions/account_driver/index';

/* Components */
import Header from '../../components/driver_record/header';
import TitleMain from '../../components/common/titleMain';
import Label from '../../components/common/label';
import TravelAndEventsMap from '../../components/driver_behavior/travelAndEventsMap';
import TravelsTable from '../../components/driver_behavior/travelsTable';
import TravelDetailModal from '../../components/driver_behavior/travelDetailModal';
import DailyBehaviorGradeGraph from '../../components/common/behavior/dailyBehaviorGradeGraph';
import BehaviorIndicatorsBlock from '../../components/common/behavior/behaviorIndicatorsBlock';
import FatigueIndicators from '../../components/common/fatigue/fatigueIndicators';
import FatigueMoreDetailsModal from '../../components/common/fatigue/fatigueMoreDetailsModal';
import DriverBiocompatibilityIndexEvolutionGraph from '../../components/driver_fatigue/driverBiocompatibilityIndexEvolutionGraph';
import DriverWorkshiftsGraph from '../../components/common/fatigue/driverWorkshiftsGraph';
import CircularIndicator from '../../components/common/indicators/circularIndicator';
import SimpleIndicator from '../../components/common/indicators/simpleIndicator';
import Avatar from '../../components/common/avatar';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import AvatarImg from '../../../../public/images/nopicture.png';
import Expired from '../expired/index';

class DriverRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTravelModal: false,
      freshLoad: false,
      driver: 0,
      showMoreDetailsModal: false
    };
  }

  componentWillUnmount() {
    this.props.actions.resetDriverRecord();
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('behaviour');
    const permit2 = permits.includes('fatigue');
    if (permit && permit2) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (
          obj.generalSetting.views.includes('behaviour') &&
          obj.generalSetting.views.includes('fatigue')
        ) {
          const obj = JSON.parse(this.props.setting.value);
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          const driver = this.props.filters.driver ? this.props.filters.driver.id : null;
          this.state.driver = driver;

          await this.props.accountDriverActions.fetchAccountDriverApi({
            dateStart,
            dateEnd,
            tags,
            seeFilter: true
          });
          await this.props.actions.fetchDriverRecordApi({
            dateStart,
            dateEnd,
            tags,
            driver: driver
          });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.props.loading == true && nextProps.loading == false && nextProps.status == 200) {
      this.state.freshLoad = true;
    }
  }

  componentDidUpdate() {
    if (this.state.freshLoad == true) {
      var firstRowTravel = $('#t-travels-table-0');
      this.state.freshLoad = false;
      if (firstRowTravel.length > 0) {
        firstRowTravel.click();
      }
    }
  }

  handleMoreDetailsClick = e => {
    e.preventDefault();
    this.setState({
      showMoreDetailsModal: true
    });
  };

  handleOnHideMoreDetailsModal = () => {
    this.setState({
      showMoreDetailsModal: false
    });
  };

  handleTravelClick = async id => {
    await this.props.driverBehaviorActions.fetchMapApi(id);
  };

  handleTravelDetailClick = e => {
    e.preventDefault();
    this.setState({
      showTravelModal: true
    });
  };

  handleOnHideTravelDetailModal = () => {
    this.setState({
      showTravelModal: false
    });
  };

  handleSubmit = async obj => {
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;

    let driver = this.state.driver;
    let driverText = null;
    if (obj.id == 'driver') {
      driver = Number.isInteger(obj.value) ? obj.value : 0;
      if (Number.isInteger(obj.value)) {
        driverText = this.props.accountDriverDatos.find(o => o.id === obj.value);
      } else {
        driverText = null;
      }
      this.setState({ driver });
    }

    /* TAGS */
    const tags = ObjGeneral.getTags(obj);
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);

    this.props.actions.setFilterDriverRecord({
      tags,
      date,
      driver: driverText
    });

    await this.props.accountDriverActions.fetchAccountDriverApi({
      seeFilter: true,
      tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });

    await this.props.actions.fetchDriverRecordApi({
      tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      driver
    });
  };

  render() {
    if (this.props.setting) {
      const lang = localStoreFN().getItem('lang');
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.driverRecord,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const { graphColorRange } = obj;
      const behaviorConfig = obj.behaviorConfig[lang];
      const language = this.props.language ? this.props.language.filter : '';
      return (
        <section className="main full-height driver-record">
          <Header
            loadingFilter={this.props.loadingFilter}
            filters={this.props.filters}
            filter={setting.filter}
            date={this.props.dateMax[2]}
            handleSubmit={this.handleSubmit}
            drivers={this.props.accountDriverDatos}
            language={language}
          />
          {this.props.loading || this.props.accountDriverLoading ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 ||
            (this.props.statusTags === 401 && this.props.accountDriverStatus == 401) ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 &&
            this.props.datos.fatigue &&
            this.props.datos.behavior &&
            this.props.statusTags === 200 &&
            this.props.accountDriverStatus == 200 ? (
            <div className="main-container">
              <div className="top-row">
                <div className="left-col">
                  <div className="top-left-section">
                    <div className="vertical-container">
                      <section className="driver-info">
                        <section className="avatar-image-wrapper">
                          <Avatar width={90} src={`${AvatarImg}`} />
                          {this.props.datos.behavior.driverName && (
                            <Label label={this.props.datos.behavior.driverName.toUpperCase()} />
                          )}
                        </section>
                        <section className="driver-grade-wrapper">
                          <section className="driver-biocompatibility-grade-wrapper">
                            <CircularIndicator
                              size={80}
                              max={100}
                              value={this.props.datos.fatigue.lastIBC}
                              thickness={6}
                              fontSize={'26px'}
                              graphColorRange={graphColorRange.fatigueBiocompatibilityIndex}
                            />
                            <Label
                              label={this.props.language.driver_fatigue.title.biocompatibilityIndex}
                            />
                          </section>
                          <section className="driver-behavior-grade-wrapper">
                            <CircularIndicator
                              size={80}
                              max={100}
                              value={this.props.datos.behavior.behaviorGrade}
                              fill={false}
                              thickness={6}
                              fontSize={'26px'}
                              valueFormat={{ type: 'NUMBER', format: '.0f' }}
                              graphColorRange={graphColorRange.behaviorGrade}
                            />
                            <Label
                              label={this.props.language.driver_behavior.labels.behaviorGrade}
                            />
                          </section>
                        </section>
                      </section>
                    </div>
                  </div>
                </div>
                <div className="right-col">
                  <section className="driver-evolution-graph">
                    <TitleMain
                      className={'second'}
                      title={this.props.language.fatigue_indicators.labels.evFatigue}
                    />
                    {this.props.datos.fatigue.evolutionsIBC.length > 0 && (
                      <DriverBiocompatibilityIndexEvolutionGraph
                        tooltip={this.props.language.driver_fatigue.graphToolTip}
                        data={this.props.datos.fatigue.evolutionsIBC}
                        graphColorRange={graphColorRange.fatigueBiocompatibilityIndex}
                      />
                    )}
                  </section>
                  <section className="driver-evolution-graph">
                    <TitleMain
                      className={'second'}
                      title={this.props.language.fatigue_indicators.labels.noteDaily}
                    />
                    {this.props.datos.behavior.behaviorDriverDailySummaryList.length > 0 && (
                      <DailyBehaviorGradeGraph
                        tooltip={this.props.language.driver_behavior.graphTooltip.behaviorGrade}
                        data={this.props.datos.behavior.behaviorDriverDailySummaryList}
                        graphColorRange={graphColorRange.behaviorGrade}
                      />
                    )}
                  </section>
                </div>
              </div>
              <div className="bottom-row">
                <Tabs
                  className={'tabPanel tabWidth2'}
                  defaultActiveKey={0}
                  bsStyle="pills"
                  animation={true}
                  id={'bottom-row-tabPanel'}
                  mountOnEnter={true}
                >
                  <Tab
                    key={0}
                    eventKey={0}
                    title={this.props.language.driver_behavior.title.mainIndicators}
                  >
                    <div className="tab-inner-wrapper behavior-content">
                      <section className="driver-indicators">
                        {this.props.datos.behavior.indicatorSummaryList.length > 0 &&
                          behaviorConfig && (
                            <BehaviorIndicatorsBlock
                              data={{
                                behaviorGrade: this.props.datos.behavior.behaviorGrade,
                                indicators: this.props.datos.behavior.indicatorSummaryList
                              }}
                              config={behaviorConfig.indicators}
                              graphColorRange={graphColorRange.behaviorGrade}
                            />
                          )}
                      </section>
                      <section className="driver-travels-wrapper">
                        <section className="driver-travels">
                          <TitleMain title={this.props.language.driver_behavior.title.travels} />
                          <section className="travel-idicators">
                            <SimpleIndicator
                              value={this.props.datos.behavior.amountDrivenKms}
                              valueFormat={{ type: 'NUMBER', format: '.0f', sufix: ' Km' }}
                            />
                            <SimpleIndicator
                              value={this.props.datos.behavior.amountDrivenHours}
                              valueFormat={{ type: 'NUMBER', format: '.0f', sufix: ' Hrs' }}
                            />
                          </section>
                          {this.props.datos.behavior.behaviorTripDetailGeneralList.length > 0 && (
                            <TravelsTable
                              handleTravelClick={this.handleTravelClick}
                              data={this.props.datos.behavior.behaviorTripDetailGeneralList}
                              graphColorRange={graphColorRange.behaviorGrade}
                            />
                          )}
                        </section>
                        <section className="driver-travel-map">
                          {behaviorConfig && (
                            <TravelAndEventsMap
                              data={this.props.datosMap}
                              loadingMap={this.props.loadingMap}
                              config={behaviorConfig.events}
                            />
                          )}
                          {this.props.datosMap.detail && (
                            <div
                              className="indicators-detail-button"
                              onClick={this.handleTravelDetailClick}
                            >
                              {this.props.language.driver_behavior.buttons.travelDetail}
                            </div>
                          )}
                        </section>
                      </section>
                    </div>
                  </Tab>
                  <Tab
                    key={1}
                    eventKey={1}
                    title={this.props.language.driver_fatigue.title.indicators}
                  >
                    <div className="tab-inner-wrapper fatigue-content">
                      <div className="indicators-wrapper">
                        <section className="operation-indicators">
                          {this.props.datos.fatigue.mainIndicators && (
                            <FatigueIndicators
                              language={language ? this.props.language.fatigue_indicators.labels : ''}
                              data={this.props.datos.fatigue.mainIndicators}
                              graphColorRange={graphColorRange.fatigueIndicators}
                              driverView={true}
                            />
                          )}
                          <div
                            className="indicators-detail-button"
                            onClick={this.handleMoreDetailsClick}
                          >
                            {this.props.language.driver_fatigue.buttons.moreDetails}
                          </div>
                        </section>
                      </div>
                      <div className="shifts-wrapper">
                        <section className="workshifts-component">
                          <TitleMain
                            className={'second'}
                            title={this.props.language.driver_fatigue.title.workshifts}
                          />
                          {this.props.datos.fatigue.shiftsList.length > 0 && (
                            <DriverWorkshiftsGraph
                              data={this.props.datos.fatigue.shiftsList}
                              tooltip={this.props.language.driver_fatigue.graphToolTip}
                              graphLabels={this.props.language.driver_fatigue.graphEventsLabels}
                              language={this.props.language}
                            />
                          )}
                        </section>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
              {behaviorConfig && (
                <TravelDetailModal
                  language={this.props.language}
                  data={this.props.datosMap.detail}
                  onHide={this.handleOnHideTravelDetailModal}
                  show={this.state.showTravelModal}
                  config={behaviorConfig.indicators}
                  graphColorRange={graphColorRange.behaviorGrade}
                />
              )}
              {this.props.datos.fatigue.mainIndicatorsDetail && (
                <FatigueMoreDetailsModal
                  language={this.props.language}
                  data={this.props.datos.fatigue.mainIndicatorsDetail}
                  onHide={this.handleOnHideMoreDetailsModal}
                  show={this.state.showMoreDetailsModal}
                />
              )}
              <Tooltip placement="top" id="pageTooltip" />
            </div>
          ) : this.props.status === 500 || this.props.statusTags === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}

const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  accountDriverDatos: state.reducer.accountDriver.datos,
  accountDriverStatus: state.reducer.accountDriver.status,
  accountDriverLoading: state.reducer.accountDriver.loading,

  language: state.reducer.dashboard.language,
  dateMax: state.reducer.dashboard.dateMax,
  setting: state.reducer.dashboard.setting,

  datos: state.reducer.driverRecord.datos,
  loading: state.reducer.driverRecord.loading,
  status: state.reducer.driverRecord.status,
  datosMap: state.reducer.driverBehavior.datosMap,
  loadingMap: state.reducer.driverBehavior.loadingMap,
  statusMap: state.reducer.driverBehavior.statusMap,
  filters: state.reducer.driverRecord.filters
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(driverRecordActions, dispatch),
  driverBehaviorActions: bindActionCreators(driverBehaviorActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch)
});

DriverRecord.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverRecord);



// WEBPACK FOOTER //
// ./source/client/containers/driver_record/index.jsx